module.exports = __webpack_public_path__ + "img/sw_logo_svg_3.svg";